export const creativeGroupsConstants = {
  SET_CREATIVE_GROUPS: 'SET_CREATIVE_GROUPS',
  FETCH_CREATIVE_GROUPS: 'FETCH_CREATIVE_GROUPS',
};
